import { GenericModel } from "../../generic.model";

export class VendorModel extends GenericModel {
    public code: string;

    protected fromJson(json?: any): boolean {
        this.code = json.code ?? null;
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.code !== null;
    }
}